var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{staticStyle:{"display":"block"}},[_c('question-pools-index')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }